import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

// Inline Google G mark (SVG, ~24px)
function GoogleMark() {
  return (
    <svg width="18" height="18" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
      <path fill="none" d="M0 0h48v48H0z"/>
    </svg>
  );
}

export default function Login() {
  const { login, loginWithGoogle, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email, password);
    setLoading(false);
    if (ok) nav("/dashboard");
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16 sm:py-24">
      <div className="overline mb-3">Sign in</div>
      <h1 className="font-serif text-4xl text-[#EFE8D8] mb-8">Welcome back.</h1>

      <button
        type="button"
        onClick={loginWithGoogle}
        data-testid="login-google"
        className="btn-ghost w-full justify-center gap-3 !bg-[#EFE8D8] !text-[#14120F] hover:!bg-white hover:!border-[#C6A15B]"
      >
        <GoogleMark /> <span>Continue with Google</span>
      </button>

      <div className="flex items-center gap-3 my-6" aria-hidden="true">
        <div className="flex-1 h-px bg-[rgba(239,232,216,0.1)]" />
        <span className="text-[10px] font-mono uppercase tracking-widest text-[#756F67]">or use email</span>
        <div className="flex-1 h-px bg-[rgba(239,232,216,0.1)]" />
      </div>

      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="block text-xs uppercase tracking-widest text-[#756F67] mb-2 font-mono">Email</label>
          <input
            data-testid="login-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="input-ink"
            autoComplete="email"
          />
        </div>
        <div>
          <label className="block text-xs uppercase tracking-widest text-[#756F67] mb-2 font-mono">Password</label>
          <input
            data-testid="login-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="input-ink"
            autoComplete="current-password"
          />
        </div>
        {error && <div data-testid="login-error" className="text-sm text-[#A04A3C]">{String(error)}</div>}
        <button data-testid="login-submit" type="submit" disabled={loading} className="btn-brass w-full justify-center">
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>
      <p className="mt-8 text-sm text-[#A8A196]">
        No account yet?{" "}
        <Link to="/register" data-testid="login-to-register" className="text-[#C6A15B] hover:underline">Create one</Link>
      </p>
    </div>
  );
}
